/**
 * @generated SignedSource<<1612a85b6d05ab21abaa971006b201db>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamManagementField_User$data = {
  readonly profile: {
    readonly managedTeamSize: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "TeamManagementField_User";
};
export type TeamManagementField_User$key = {
  readonly " $data"?: TeamManagementField_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamManagementField_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamManagementField_User",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "managedTeamSize",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "abce089c7edef2a4e8f212050e1ad85d";

export default node;
